import { render, staticRenderFns } from "./QxTop.vue?vue&type=template&id=61141c8e&scoped=true"
import script from "./QxTop.vue?vue&type=script&lang=js"
export * from "./QxTop.vue?vue&type=script&lang=js"
import style0 from "./QxTop.vue?vue&type=style&index=0&id=61141c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61141c8e",
  null
  
)

export default component.exports